var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogle(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 15.3409C29 14.2773 28.9058 13.2545 28.731 12.2727H14.7959V18.0818H22.7588C22.4091 19.95 21.3599 21.5318 19.7862 22.5955V26.3727H24.5881C27.3859 23.7545 29 19.9091 29 15.3409Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7959 30C18.7908 30 22.1401 28.6636 24.5881 26.3727L19.7862 22.5955C18.468 23.4955 16.7866 24.0409 14.7959 24.0409C10.949 24.0409 7.68043 21.4091 6.5102 17.8636H1.5872V21.7364C4.0218 26.6318 9.01206 30 14.7959 30Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5102 17.85C6.21429 16.95 6.03942 15.9955 6.03942 15C6.03942 14.0045 6.21429 13.05 6.5102 12.15V8.27727H1.5872C0.578386 10.2955 0 12.5727 0 15C0 17.4273 0.578386 19.7045 1.5872 21.7227L5.42069 18.6955L6.5102 17.85Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7959 5.97273C16.975 5.97273 18.9119 6.73636 20.4587 8.20909L24.6957 3.91364C22.1266 1.48636 18.7908 0 14.7959 0C9.01206 0 4.0218 3.36818 1.5872 8.27727L6.5102 12.15C7.68043 8.60455 10.949 5.97273 14.7959 5.97273Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.0f924400.svg";
export { ForwardRef as ReactComponent };